const megaMenu = document.querySelectorAll(".mega-menu__ul");

megaMenu.forEach((menu) => {
  menu.childNodes.forEach((child) => {
    child.addEventListener("click", () => {
      sessionStorage.removeItem("search_choices");
      sessionStorage.removeItem("choices");
      sessionStorage.removeItem("search_products");
      sessionStorage.removeItem("products");
    });
  });
});

const mobileMenu = document.querySelector(".menu-drawer__menu.list-menu");

mobileMenu.childNodes.forEach((child) => {
  child.addEventListener("click", () => {
    sessionStorage.removeItem("search_choices");
    sessionStorage.removeItem("choices");
    sessionStorage.removeItem("search_products");
    sessionStorage.removeItem("products");
  });
});
